import React, { useRef } from "react";
import { Link } from "react-router-dom";

import { CCarousel, CCarouselItem, CImage } from "@coreui/react";
import serverPath from ".././serverpath.js";

import Popbox from "../PopBox.jsx";

const HomePlusHelp = () => {
	const [slide, setSlide] = React.useState([]);
	// console.log(slide);

	const [bCallPopbox, setbCallPopbox] = React.useState(false);
	const [PopboxData, setPopboxData] = React.useState("alert toast");
	const deployPopbox = (contentObj) => {
		setPopboxData(contentObj);
		setbCallPopbox(true);
	};
	const afPopEnd = (e) => {
		e.stopPropagation();
		setbCallPopbox(false);
	}

	const sliderRef = useRef(null);
	// console.log('hjhjkhkj', sliderRef);

	/* React.useEffect(() => {
		const timeoutId = setTimeout(() => {
			setbCallPopbox(false);
		}, 20000);
		// Clear the timeout if the component is unmounted before the timeout expires
		return () => {
			clearTimeout(timeoutId);
		};
	}, [bCallPopbox]); */

	// const navprocess = (boxerr) => {
	// 	// Set a timeout to hide the component after 5 seconds
	// 	const timeoutId = setTimeout(() => {
	// 		props.deployNotifier(boxerr);
	// 		setTimeout(() => {
	// 			navigate(-1);
	// 		}, 4000);
	// 	}, 2000);
	// 	return () => clearTimeout(timeoutId);
	// };

	React.useEffect(() => {
		fetch("/slider.json")
			.then((response) => response.json())
			.then((data) => setSlide(data))
			.catch((error) => console.error("Error fetching JSON:", error));
	}, []);
	return (
		<div className="home-compo" ref={sliderRef} onKeyDown={(e) => console.log('-----',e.key)}>
			{slide?.length > 0 ? (
				<>
					<CCarousel controls indicators>
						{slide[0].length > 0 &&
							slide[0].map((name, i) => {
								return (
									<CCarouselItem key={i}>
										<CImage className="d-block w-100" src={`${serverPath.dypath}${name}`} alt="slide 1" />
									</CCarouselItem>
								);
							})}
					</CCarousel>

					<div className="feature-content">
						<h1>Feature & Anouncement</h1>
						<div className="feature-card">
							{slide[1].length > 0 &&
								slide[1].map((card, i) => {
									return (
										<div className="thecard" key={i}>
											<div className="card-img">
												<img src={`${serverPath.dypath}${card.image}`} alt="" />
											</div>
											<div className="card-content">
												<div className="card-text">
													<div className="card-title">{card.title}</div>
													<p className="card-desc">{card.content}</p>
												</div>
												<Link onClick={card?.desc?.length ? (e) => deployPopbox(card, e) : null} to={card?.desc?.length ? null : card.btnlink} target={card?.desc?.length ? null : "_blank"}>
													<div className="card-btn">{card?.desc?.length ? "Read More..." : "Know more"}</div>
												</Link>
											</div>
										</div>
									);
								})}
						</div>
					</div>
				</>
			) : (
				<h2>Loading ...</h2>
			)}

			{bCallPopbox && <Popbox popupDataObj={PopboxData} closeBox={afPopEnd}/>}
		</div>
	);
};

export default HomePlusHelp;
